import React, { FC } from 'react';
import { DisplayWidthForCards, Section, createContainer } from '@everfi/reactifi';
import { Outlet } from 'react-router';

import config from '../config/teacherRegistrationContainerConfig';

export const TeacherWelcomeContainer: FC = ({ ...props }) => {
  const Container = createContainer(config);

  return (
    <Container {...props}>
      <Section type="cards">
        <DisplayWidthForCards>
          <Outlet />
        </DisplayWidthForCards>
      </Section>
    </Container>
  );
};

export default TeacherWelcomeContainer;
